/**
 * Created by neo on 16.10.21.
 */
import { makeAutoObservable } from 'mobx';

// Raw JSON from backend
export type AggregationResultEntryJson = {
  type: string;
  total: Record<string, number>;
  count: number;
};

// Observable model type (extends JSON)
export type AggregationResultEntry = AggregationResultEntryJson;

// Factory function
export function createAggregationResultEntry(json?: Partial<AggregationResultEntryJson>): AggregationResultEntry {
  return makeAutoObservable({
    type: json?.type ?? '',
    total: json?.total ?? {},
    count: json?.count ?? 0,
  });
}
